module.exports = __webpack_public_path__ + "img/booth-map.b995c124.png";